module.exports = __webpack_public_path__ + "static/media/Pfister.1385b546.svg";